export default __webpack_public_path__ + "static/media/martijn.2139715e.png";